<div class="particle-effects-overlay-container" #overlayParent>
  @if (currentParticleComponent === particleEffectsTypes.SNOW) {
  <app-snow-effect></app-snow-effect>
  }
</div>
